import ability from './ability';

export const canNavigate = (to) => {
  if (!to?.matched?.length) {
    // Si no hay rutas coincidentes, no se permite la navegación
    return false;
  }

  return to.matched.some((route) => {

    // Asignar valor por defecto a action si no está definido
    const action = route.meta?.action;
    const resource = route.meta?.resource;
    

    // Verificar si action y resource están definidos
    if (!action || !resource) {
      return false;
    }
    
    // Verificar permisos con la habilidad
    return ability.can(action, resource);
  });
};

export const _ = undefined;